export enum PREventTypeEnum {
    emailDistribution,
    newswire,
    custom
}
